import savageWorlds from "./savageWorlds";

const spellSchools = [
  "",
  "Abjuration",
  "Clairsentience",
  "Conjuration",
  "Divination",
  "Enchantment",
  "Evocation",
  "Illusion",
  "Metapsionics",
  "Necromancy",
  "Psychokinesis",
  "Psychometabolism",
  "Psychoportation",
  "Special",
  "Telepathy",
  "Transmutation",
  "Universal"
];

const savageEmbers = {
  spellSchools: spellSchools
};

const ruleset = { ...savageEmbers, ...savageWorlds };

export default ruleset;
